import { render, staticRenderFns } from "./ChartjsBarChartHappiness.vue?vue&type=template&id=4dbe40e1&"
import script from "./ChartjsBarChartHappiness.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChartHappiness.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsBarChartHappiness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports